<template>
    <div class="modal fade" tabindex="-1" id="EsqueciMinhaSenha">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content border-0">
                <div class="modal-body">
                    <div class="py-4 px-4">
                        <h3>Esqueceu sua senha ?</h3>
                        <hr/>
                        <p class="small">Informe seu e-mail de login para enviarmos uma nova senha.</p>
                        <div class="row g-3">
                            <div class="col-12">
                            <form class="" id="formEsqueciSenha">
                                <div class="form-group">
                                    <label class="form-label" for="email-address">Email</label>
                                    <div class="form-control-wrap">
                                        <input type="text" class="form-control" id="email" placeholder="Digite seu e-mail" v-model="email" maxlength="100" required>
                                    </div>
                                </div>
                            </form>
                                
                            </div><!-- .col -->
                            <div class="col-12">
                                <button class="btn btn-primary w-100" type="button" @click="enviar">Enviar</button>
                            </div><!-- .col -->
                        </div><!-- .row -->
                    </div>
                </div><!-- .modal-body -->
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg><!-- x-lg -->
                </button><!-- modal-close -->
            </div><!-- .modal-content -->
        </div><!-- .modal-dialog -->
    </div><!-- .modal -->
</template>

<script>
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'EsqueciMinhaSenha',
        data: function () {
            return {
                email: null,
            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            validar() {
                if (this.email == '' || this.email == null) {
                    return false;
                }

                return true;
            }
        },
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Auth/forgotPassword`, { login: $this.email })
                        .then(function(){
                            avisoSucesso("Sua solicitação foi registrada, verifique seu e-mail!");
                            $this.$refs['modal-esqueci-senha'].hide();
                        })
                        .catch(res => {
                            if (res.response.data != undefined) {
                                avisoErro(res.response.data.msg);
                            } else {
                                avisoErro(res.response.statusText);
                            }
                        });
                }
                return false;
            },

            checkForm() {
                var form = document.getElementById('formEsqueciSenha')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            close() {
                const myModalAlternative = new window.bootstrap.Modal('#EsqueciMinhaSenha');
                myModalAlternative.hide();
            }
        },
        created: function () {
            
        },
        watch: {
            showModal: function () {
                const myModalAlternative = new window.bootstrap.Modal('#EsqueciMinhaSenha');
                myModalAlternative.show();
            },
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* MODAL ESQUECI MINHA SENHA */
    

</style>